<template>
  <dd-customer-page header="Test pagina" customer-id="1">
    <template v-slot:buttons>
      <dd-rounded-button icon="mdi mdi-plus">
        lorem ipsum
      </dd-rounded-button>
    </template>
    <template v-slot:content>

      <dd-sub-tab-group id="tabSelector" class="mb-md">
        <dd-sub-tab>
          Pagina 1
        </dd-sub-tab>
        <dd-sub-tab>
          Pagina 2
        </dd-sub-tab>
        <dd-sub-tab>
          Pagina 3
        </dd-sub-tab>
        <dd-sub-tab>
          Pagina 4
        </dd-sub-tab>
      </dd-sub-tab-group>

      <dd-sub-tab-content-wrapper id="tabSelector">
        <dd-sub-tab-content>
          <dd-grid>

            <dd-grid-item :col-span-prop="1">
              <dd-header-card header="Rounded Buttons">
                <div class="flex-col flex-wrap gap-sm">
                  <dd-rounded-button type="primary" icon="mdi mdi-plus">
                    lorem ipsum
                  </dd-rounded-button>
                  <dd-rounded-button type="warning" icon="mdi mdi-plus">
                    lorem ipsum
                  </dd-rounded-button>
                  <dd-rounded-button type="outline" icon="mdi mdi-plus">
                    lorem ipsum
                  </dd-rounded-button>
                </div>
              </dd-header-card>
            </dd-grid-item>

            <dd-grid-item :col-span="1">
              <dd-header-card icon="mdi mdi-plus" header="Large figure">
                <dd-card-large-text title="€ 2,500" />
              </dd-header-card>
            </dd-grid-item>

            <dd-grid-item :col-span="1">
                <dd-header-card header="Een interresante optie" style="height: 100%">
                    <p>Doe eens gek, sta op de kop. Onderaan niet. Wat doen swe met langere teksten? schaalt de card dan groter? En zit je dan met het feit dat daardoor weer ruimte overblijft bij andere cards?</p>
                </dd-header-card>
            </dd-grid-item>

            <dd-grid-item :col-span="2">
              <dd-card>
                <dd-form @submit="onSubmit">

                  <dd-step title="Basis gegevens" :cols="2">
                        <dd-input
                          title="Naam"
                          name="full_name"
                          placeholder="Voer je naam in..."
                          rules="required"
                          v-model="full_name"
                        ></dd-input>

                        <dd-select
                          title="Geslacht"
                          name="sex"
                          rules="required"
                          v-model="gender"
                        >
                            <a-select-option value="man">Man</a-select-option>
                            <a-select-option value="vrouw">Vrouw</a-select-option>
                            <a-select-option value="anders">Anders...</a-select-option>
                        </dd-select>
                        <dd-form-grid-item :cols="2">
                            <dd-textarea
                              title="Beschrijving"
                              placeholder="Voer een omschrijving in"
                              name="general_description"
                              v-model="textarea"
                              rules="required"
                            />
                        </dd-form-grid-item>
                        <dd-checkbox
                            title="Ondersteboven"
                            rules="required"
                            v-model="upsidedown"
                        />
                        <dd-switch
                          title="Ondersteboven"
                          name="upsidedown"
                          v-model="upsidedown"
                        />
                  </dd-step>

                    <dd-step title="Test gegevens">
                        <dd-form-grid-item :cols="3" class="flex-col gap-xs">
                          <dd-switch title="Ondersteboven" name="upsidedown" v-model="upsidedown"/>
                          <dd-switch title="Gespiegeld" name="mirrored"/>
                        </dd-form-grid-item>
                        <dd-form-grid-item :cols="3">
                            <dd-textarea title="Beschrijving" placeholder="Voer een omschrijving in" name="general_description"/>
                        </dd-form-grid-item>
                    </dd-step>

                  <dd-step title="Adres gegevens" :cols="2">

                      <dd-input title="Naam" placeholder="Vul je naam in..." name="another_name"></dd-input>
                      <dd-textarea title="Beschrijving" placeholder="Voer een omschrijving in..." name="another-description"></dd-textarea>

                      <dd-date-range-picker
                        title="Geboortedatum"
                        name="birth_date"
                        rules="required"
                        v-model="birthdate"
                      ></dd-date-range-picker>

                      <dd-multi-switch group-name="multiSwitchComponent" title="Selecteer een optie" @input="switchInput">
                          <dd-multi-switch-item title="Optie 1" :value="0" active/>
                          <dd-multi-switch-item title="Optie 2" :value="1"/>
                          <dd-multi-switch-item title="Optie 3" :value="2"/>
                      </dd-multi-switch>

                  </dd-step>

                </dd-form>
              </dd-card>
            </dd-grid-item>

          </dd-grid>
        </dd-sub-tab-content>

        <dd-sub-tab-content>
          foo
        </dd-sub-tab-content>

        <dd-sub-tab-content>
          <dd-radio-group v-model="radiobuttongroup" group-name="bar" rules="required">
            <dd-radio value="foo">
              foo
            </dd-radio>
            <dd-radio value="bar">
              bar
            </dd-radio>
            <dd-radio value="foobar">
              foobar
            </dd-radio>
          </dd-radio-group>
        </dd-sub-tab-content>
        <dd-sub-tab-content>
          <dd-masonry>
            <dd-masonry-grid-item :col-span="3">
              <dd-header-card header="Een interresante optie" style="height: 100%">
                <template #action>
                  <button>
                    Click me
                  </button>
                </template>
                <p>Doe eens gek, sta op de kop. Onderaan niet. Wat doen swe met langere teksten? schaalt de card dan groter? En zit je dan met het feit dat daardoor weer ruimte overblijft bij andere cards?</p>
              </dd-header-card>
            </dd-masonry-grid-item>
            <dd-masonry-grid-item :col-span="2">
              <dd-header-card header="Een interresante optie" style="height: 100%">
                <p>Doe eens gek, sta op de kop. Onderaan niet. Wat doen swe met langere teksten? schaalt de card dan groter? En zit je dan Doe eens gek, sta op de kop. Onderaan niet. Wat doen swe met langere teksten? schaalt de card dan groter? En zit je dan Doe eens gek, sta op de kop. Onderaan niet. Wat doen swe met langere teksten? schaalt de card dan groter? En zit je dan met het feit dat daardoor weer ruimte overblijft bij andere cards?</p>
              </dd-header-card>
            </dd-masonry-grid-item>
            <dd-masonry-grid-item :col-span="1">
              <dd-header-card header="Een interresante optie" style="height: 100%">
                <p>Doe eens gek, sta op de kop. Onderaan niet. Wat doen swe met langere teksten? schaalt de card dan groter? En zit je dan met het feit dat daardoor weer ruimte overblijft bij andere cards?</p>
              </dd-header-card>
            </dd-masonry-grid-item>
          </dd-masonry>
          <dd-multi-switch title="foo" group-name="groupName">
            <dd-multi-switch-item value="y" title="foo">

            </dd-multi-switch-item>
            <dd-multi-switch-item value="x" title="foo">

            </dd-multi-switch-item>


          </dd-multi-switch>
        </dd-sub-tab-content>


      </dd-sub-tab-content-wrapper>



    </template>
    <template v-slot:tabs></template>
  </dd-customer-page>
</template>

<script>
export default {
  name: "ComponentTestPage",
  methods: {
    onSubmit(formData) {
      console.log('Submit!!');
      for(let [key, value] of formData.entries()){
        console.log(key, value)
      }
    },
    updateSelected(newSelectedRows) {
      console.log(newSelectedRows);
      this.selectedRows = newSelectedRows;
    },
    switchInput(e){
      console.log(e);
    }
  },
  data() {
    return {
      selectedRows: [],
      date: null,
      switchValue: false,
      selectValue: 'foo',
      textareaValue: 'foo',
      inputValue: 'x',
      radioValue: 'foo',
      full_name: "",
      gender: undefined,
      textarea: "",
      upsidedown: false,
      birthdate: undefined,
      radiobuttongroup: undefined,
      list: {
        "Minimale AOW leeftijd": "01/01/2057",
        "Aantal maanden tot minimale AOW datum": "402 mnd (33 jr 6 mnd)",
        "Bruto jaarlijkse AOW-bedrag": "€ 0,00",
        "Bruto jaarlijkse werknemerspensioen": "€ 0,00",
        "Privé levensverzekering(en)": "€ 0,00",
        "Bruto jaarlijkse partnerpensioen": "€ 0,00",
        "Bruto jaarlijkse privé pensioen": "€ 0,00",
        "Bruto jaarlijks pensioen": "€ 0,00"
      },
      table: {
        headers: [
          {
            title: 'qux',
            key: 'qux',
            type: String,
          },
          {
            title: 'quux',
            key: 'quux',
            type: String,
          }
        ],
        rows: [
          {
            id: 0,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor',
          },
          {
            id: 1,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          // Additional rows
          {
            id: 2,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 3,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 4,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 5,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 6,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 7,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 8,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 9,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          }
        ]
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
